export const planningTableMessages = {
	MSG_NO_DATA_TITLE: 'Atenção',
	MSG_NO_DATA_DESCRIPTION:
		'Não há plano para o ciclo selecionado. Por favor, primeiro realize o planejamento.',

	MSG_LEAVE_PAGE_DESCRIPTION:
		'Você possui alterações não salvas neste plano. Deseja realmente mudar de página e perder as modificações?',
	MSG_LEAVE_COMPONENT_DESCRIPTION:
		'Você possui alterações não salvas neste plano. Deseja realmente realizar essa ação e perder as modificações?',

	MSG_LEAVE_TITLE: 'Alterações não salvas detectadas!',
};
